import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

export function generateOutletInvoicePdf(invoiceNo, invoiceData, company) {
  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 10;

  company = company || {};
  const { items = [], partyName = "", address = "", partyPhone = "", gstno = "", date = "" } = invoiceData;

  // 1. HEADER
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(14);
  pdf.text(company.name || "RUBY AGENCIES", pageWidth / 2, 15, { align: "center" });

  pdf.setFontSize(10);
  pdf.setFont("helvetica", "normal");
  const fullAddress = (company.address1 || "") + (company.address2 ? ", " + company.address2 : "");
  pdf.text(fullAddress, pageWidth / 2, 20, { align: "center" });
  pdf.text(`Phone : ${company.phone || ""}`, pageWidth / 2, 24, { align: "center" });
  pdf.text(`GSTIN : ${company.gstin || ""}`, pageWidth / 2, 28, { align: "center" });
  pdf.text(`PAN : ${company.pan || ""}`, pageWidth / 2, 32, { align: "center" });

  // 2. TO SECTION
  const oAddress = invoiceData.outletAddress || invoiceData.address || "";
  const oPhone = invoiceData.outletPhone || invoiceData.partyPhone || "";
  const oGstin = invoiceData.outletGstin || invoiceData.gstno || "";
  const oState = invoiceData.outletStateCode || "";
  const oName = invoiceData.outletName || partyName;

  pdf.line(margin, margin + 25, pageWidth - margin, margin + 25);
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(11);
  pdf.text("To : " + oName, margin, margin + 35);
  
  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(10);
  const splitAddress = pdf.splitTextToSize("Address : " + oAddress, pageWidth / 1.5 - margin);
  pdf.text(splitAddress, margin, margin + 42);
  
  const addressHeight = splitAddress.length * 5;
  pdf.text(`Phone : ${oPhone}`, margin, margin + 42 + addressHeight);
  pdf.text(`GSTIN : ${oGstin}` + (oState ? ` (State Code: ${oState})` : ""), margin, margin + 47 + addressHeight);

  // 3. INVOICE INFO
  pdf.setFont("helvetica", "bold");
  pdf.text(`Invoice Number : ${invoiceNo}`, margin, margin + 57 + addressHeight);
  pdf.text(`Date : ${date}`, pageWidth - margin - 40, margin + 57 + addressHeight);

  // 4. TABLE
  const tableData = items.map(item => [
    `${item.skuName || ""}\n${item.hsn || ""}`,
    `${item.rate.toFixed(2)} /\n${item.mrp.toFixed(1)}`,
    item.qty.toFixed(3),
    item.basicAmount.toFixed(2),
    item.gstAmount.toFixed(2),
    item.totalAmount.toFixed(2)
  ]);

  autoTable(pdf, {
    startY: 68 + addressHeight,
    head: [['Particulars', 'Rate/MRP', 'Qty in M', 'Basic', 'Tax', 'Total']],
    body: tableData,
    theme: 'grid',
    styles: { fontSize: 8, cellPadding: 2 },
    headStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: 'bold' },
    columnStyles: {
      0: { cellWidth: 60 },
      1: { halign: 'right' },
      2: { halign: 'right' },
      3: { halign: 'right' },
      4: { halign: 'right' },
      5: { halign: 'right' },
    }
  });

  const finalY = pdf.lastAutoTable.finalY + 10;

  // 5. FOOTER (Totals)
  const totals = items.reduce((acc, item) => {
    acc.totalQty += item.qty;
    acc.totalBasic += item.basicAmount;
    acc.totalTax += item.gstAmount;
    acc.grandTotal += item.totalAmount;
    return acc;
  }, { totalQty: 0, totalBasic: 0, totalTax: 0, grandTotal: 0 });

  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(10);
  pdf.text(`Total Items : ${items.length}`, margin, finalY);
  pdf.text(`Total Qty in M. : ${totals.totalQty.toFixed(3)}`, margin, finalY + 10);

  const cgst = (totals.totalTax / 2).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const rawGstPercent = items.length > 0 ? (items[0].gstPercent || 28) : 28;
  const halfGst = (rawGstPercent / 2).toFixed(1);

  // Totals column layout - avoiding messiness
  const rowH = 7;
  const col1L = pageWidth / 2 - 25; 
  const col1R = pageWidth / 2 + 30;
  const col2L = pageWidth - 55;
  const col2R = pageWidth - margin;

  pdf.setFontSize(9);
  // Column 1: Tax breakdown
  pdf.text(`CGST @ ${halfGst}% :`, col1L, finalY);
  pdf.text(cgst, col1R, finalY, { align: "right" });
  
  pdf.text(`SGST @ ${halfGst}% :`, col1L, finalY + rowH);
  pdf.text(cgst, col1R, finalY + rowH, { align: "right" });

  // Column 2: Financial summary
  pdf.text(`Total Basic :`, col2L, finalY);
  pdf.text(totals.totalBasic.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), col2R, finalY, { align: "right" });

  pdf.text(`Total Tax :`, col2L, finalY + rowH);
  pdf.text(totals.totalTax.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }), col2R, finalY + rowH, { align: "right" });

  const gTotal = totals.grandTotal.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  pdf.setFontSize(11);
  pdf.text(`Grand Total :`, col2L, finalY + rowH + 8);
  pdf.text(gTotal, col2R, finalY + rowH + 8, { align: "right" });

  // 6. REMARKS
  pdf.setFontSize(8);
  pdf.setFont("helvetica", "normal");
  pdf.text("Remarks: 1M = 1,000 Cigarette sticks", margin, finalY + 30);

  return pdf;
}
